const { createSlice } = require('@reduxjs/toolkit');

const initialState = {
	coupons: {
		data: [],
		error: null,
		loading: false,
		totalCount: 0,
		tableParams: {
			page: 0,
			size: 10,
		},
	},
	couponCode: { data: null, error: null, loading: false },
	coupon: { data: null, error: null, loading: false },
	createdCoupon: { data: null, error: null, loading: false },
	removedCoupon: { data: null, error: null, loading: false },
	editedCoupon: { data: null, error: null, loading: false },
};

const { actions, reducer } = createSlice({
	name: 'coupons',
	initialState,
	reducers: {
		createCoupon: (state, { payload }) => {
			state.createdCoupon = {
				...state.createdCoupon,
				data: null,
				error: null,
				loading: true,
			};
		},
		createCouponFailure: (state, { payload }) => {
			state.createdCoupon = {
				...state.createdCoupon,
				error: payload,
				loading: false,
			};
		},
		createCouponSuccess: (state, { payload }) => {
			state.createdCoupon = {
				...state.createdCoupon,
				data: payload,
				error: null,
				loading: false,
			};
		},
		getCoupons: (state, { payload }) => {
			const { saveConfig = true, ...restPayload } = payload;
			state.coupons = {
				...state.coupons,
				...(saveConfig ? { tableParams: restPayload } : {}),
				error: null,
				loading: true,
			};
		},
		getCouponsFailure: (state, { payload }) => {
			state.coupons = {
				...state.coupons,
				error: payload,
				loading: false,
			};
		},
		getCouponsSuccess: (state, { payload }) => {
			state.coupons = {
				...state.coupons,
				data: payload.body,
				totalCount: payload.meta.totalCount,
				error: null,
				loading: false,
			};
		},
		getCouponById: (state, { payload }) => {
			state.coupon = {
				...state.coupon,
				data: null,
				error: null,
				loading: true,
			};
		},
		getCouponByIdFailure: (state, { payload }) => {
			state.coupon = {
				...state.coupon,
				error: payload,
				loading: false,
			};
		},
		getCouponByIdSuccess: (state, { payload }) => {
			state.coupon = {
				...state.coupon,
				data: payload,
				error: null,
				loading: false,
			};
		},
		getCouponByCode: (state, { payload }) => {
			state.couponCode = {
				...state.couponCode,
				error: null,
				loading: true,
			};
		},
		getCouponByCodeFailure: (state, { payload }) => {
			state.couponCode = {
				...state.couponCode,
				error: payload,
				loading: false,
			};
		},
		getCouponByCodeSuccess: (state, { payload }) => {
			state.couponCode = {
				...state.couponCode,
				data: payload,
				error: null,
				loading: false,
			};
		},
		removeCoupon: (state, { payload }) => {
			state.removedCoupon = {
				...state.removedCoupon,
				data: null,
				error: null,
				loading: true,
			};
		},
		removeCouponFailure: (state, { payload }) => {
			state.removedCoupon = {
				...state.removedCoupon,
				error: payload,
				loading: false,
			};
		},
		removeCouponSuccess: (state, { payload }) => {
			state.removedCoupon = {
				...state.removedCoupon,
				data: payload,
				error: null,
				loading: false,
			};
		},
		updateCoupon: (state, { payload }) => {
			state.editedCoupon = {
				...state.editedCoupon,
				data: null,
				error: null,
				loading: true,
			};
		},
		updateCouponFailure: (state, { payload }) => {
			state.editedCoupon = {
				...state.editedCoupon,
				error: payload,
				loading: false,
			};
		},
		updateCouponSuccess: (state, { payload }) => {
			state.editedCoupon = {
				...state.editedCoupon,
				data: payload,
				error: null,
				loading: false,
			};
		},
	},
});

export const {
	createCoupon,
	createCouponFailure,
	createCouponSuccess,
	getCoupons,
	getCouponsFailure,
	getCouponsSuccess,
	removeCoupon,
	removeCouponFailure,
	removeCouponSuccess,
	updateCoupon,
	updateCouponFailure,
	updateCouponSuccess,
	getCouponById,
	getCouponByIdFailure,
	getCouponByIdSuccess,
	getCouponByCode,
	getCouponByCodeFailure,
	getCouponByCodeSuccess,
} = actions;

export { default as couponsSaga } from './saga';

export default reducer;
